export default "__VITE_ASSET__DKW6SpLT__"